import { putSubmitEntrance, putUpdatePresenceList } from "@/api/area";
import EyeIcon from "@/assets/SVG/eyeIcon";
import CustomTable from "@/components/customTable/CustomTable";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

function ManageMembers({ data, areaId }) {
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    if (data) setTableData(data);
  }, [data]);

  const colDefs = useMemo(
    () => [
      {
        field: "name",
        headerName: "نام و نام خانوادگی",
        width: 225,
      },
      {
        field: "phone",
        headerName: "شماره تلفن",
        width: 150,
      },
      {
        field: "nid",
        headerName: "کد ملی",
        width: 150,
      },
      {
        field: "field",
        headerName: "تخصص",
        width: 150,
      },
      {
        headerName: "حضور/غیاب",
        width: 150,
        cellRenderer: (x) => {
          return (
            <Grid
              key={`action_${x.data.id}`}
              display={"flex"}
              flexDirection={"row"}
              gap={"5px"}
            >
              <Button
                color={x.data.present ? "error" : "primary"}
                sx={{ fontFamily: "Vazirmatn", width: "100px" }}
                variant="contained"
                onClick={() => {
                  if (x.data.present) {
                    putUpdatePresenceList(x.data.id, areaId, undefined, {
                      justSetExit: true,
                    })
                      .then(() => {
                        setTableData(
                          tableData.map((itr) => {
                            if (itr.id !== x.data.id) return itr;
                            return {
                              ...itr,
                              present: undefined,
                            };
                          }),
                        );
                      })
                      .catch(() => {});
                  } else {
                    putSubmitEntrance(x.data.id, areaId)
                      .then(() => {
                        setTableData(
                          tableData.map((itr) => {
                            if (itr.id !== x.data.id) return itr;
                            return {
                              ...itr,
                              present: true,
                            };
                          }),
                        );
                      })
                      .catch(() => {});
                  }
                }}
              >
                {x.data.present ? "ثبت خروج" : "ثبت ورود"}
              </Button>
              <IconButton
                onClick={() =>
                  window.open(
                    `/presence_history/${areaId}/${x.data.id}`,
                    "_blank",
                  )
                }
              >
                <EyeIcon />
              </IconButton>
            </Grid>
          );
        },
      },
      {
        headerName: "شرح وظیفه در اردو",
        width: 400,
        cellRenderer: (x) => {
          return (
            <Typography
              key={`job_${x.id}`}
              fontFamily="Vazirmatn"
              variant="caption"
              sx={{ lineHeight: "unset" }}
            >
              {x?.data?.areaTripAccesses?.join(" - ")}
            </Typography>
          );
        },
      },
    ],
    [tableData],
  );

  return (
    <>
      <Typography variant="h6" color={"text.main"}>
        جهادگران
      </Typography>
      <Grid display={"flex"} flexDirection={"column"} minHeight={"400px"}>
        <CustomTable
          needPagination={false}
          rowData={tableData}
          columns={colDefs}
        />
      </Grid>
    </>
  );
}

export default ManageMembers;
